import SearchBarFilter from '@/platform/common/components/SearchBarFilter/SearchBarFilter';
import { useFilters } from '@/platform/hooks/useFilters';
import { FilterBarDropdown, FilterBarToggle } from '@/platform/ui';
import { usePage } from '@inertiajs/react';

const ONLY = ['transactions'];

// Domain\Signhost\Enums\Status::SIGNED — the status the legacy page falls back to
// when the status filter would otherwise be emptied.
const SIGNED_STATUS = 30;

const SignhostFilters = ({ statuses = [] }) => {
    const { auth } = usePage().props;
    const { filters, updateFilters } = useFilters(ONLY);

    const entities = (auth?.customer?.entities || []).map(entity => ({
        id: entity.id,
        name: entity.number ? `${entity.number}. ${entity.name}` : entity.name,
    }));

    const statusOptions = statuses.map(status => ({
        id: status.value,
        name: status.label,
    }));

    const selectedEntityIds = filters?.entityIds || [];
    const selectedStatuses = filters?.statuses || [];

    const allEntitiesSelected =
        entities.length > 0 && selectedEntityIds.length === entities.length;
    const allStatusesSelected =
        statusOptions.length > 0 &&
        selectedStatuses.length === statusOptions.length;

    // Match the legacy page: the status filter is never empty. Deselecting everything
    // (or toggling "select all" off) falls back to "Ondertekend".
    const handleStatusChange = value =>
        updateFilters('statuses', value.length === 0 ? [SIGNED_STATUS] : value);

    return (
        <SearchBarFilter only={ONLY}>
            {entities.length > 0 && (
                <FilterBarDropdown
                    label={`Entiteiten (${selectedEntityIds.length}/${entities.length})`}
                    multiple
                    selectAll={
                        allEntitiesSelected
                            ? 'Deselecteer alles'
                            : 'Selecteer alles'
                    }
                    options={entities}
                    value={selectedEntityIds}
                    onChange={value => updateFilters('entityIds', value)}
                />
            )}

            <FilterBarDropdown
                label={`Status (${selectedStatuses.length}/${statusOptions.length})`}
                multiple
                selectAll={
                    allStatusesSelected
                        ? 'Deselecteer alles'
                        : 'Selecteer alles'
                }
                options={statusOptions}
                value={selectedStatuses}
                onChange={handleStatusChange}
            />

            <FilterBarToggle
                label='Aflopend'
                title='Machtigingen die binnen 14 dagen verlopen.'
                checked={!!filters?.expiring}
                onChange={checked => updateFilters('expiring', checked ? 1 : 0)}
            />
        </SearchBarFilter>
    );
};

export default SignhostFilters;
